import React from 'react';
import PropTypes from 'prop-types';

import AirbrakeClient from 'airbrake-js';

import { Alert } from 'antd';

import {
  AIRBRAKE_PROJECT_KEY,
  AIRBRAKE_PROJECT_ID
} from './../../utils/Constants';

import './ErrorCatch.less';

class ErrorCatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };

    if (process.env.NODE_ENV !== 'development') {
      this.airbrake = new AirbrakeClient({
        projectId: AIRBRAKE_PROJECT_ID,
        projectKey: AIRBRAKE_PROJECT_KEY
      });
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    if (process.env.NODE_ENV !== 'development') {
      this.airbrake.notify({
        error,
        params: { info: errorInfo }
      });
    }
  }

  render() {
    const showDevOutput = process.env.NODE_ENV === 'development';
    const { message, description } = this.props;
    if (this.state.errorInfo) {
      return (
        <div className="error-catch">
          <Alert
            message={message}
            description={description}
            type="error"
            showIcon
          />
          {showDevOutput ? (
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {this.state.errorInfo.componentStack}
            </details>
          ) : null}
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorCatch.propTypes = {
  message: PropTypes.string,
  description: PropTypes.string
};

ErrorCatch.defaultProps = {
  message: 'Fehler',
  description: 'Es ist ein Fehler aufgetreten.'
};

export default ErrorCatch;



// WEBPACK FOOTER //
// ./src/components/ErrorCatch/index.js